import { z } from 'zod'

// Колонка доски: флаги задают поведение (countsTime — тикает время, done —
// финальная, waiting — таймер на паузе, «ждём»).
export const ColumnSchema = z.object({
  id: z.string(),
  name: z.string(),
  position: z.number().int(),
  countsTime: z.boolean(),
  done: z.boolean(),
  waiting: z.boolean(),
})
export type Column = z.infer<typeof ColumnSchema>

// Владелец доски: проект, компания или сотрудник (личная доска — входящая
// корзина для задач, ещё не принадлежащих проекту). Незнакомый вид читается как
// проектная доска: так вела себя любая доска до появления владельцев.
export const BoardOwnerSchema = z.object({
  kind: z.enum(['project', 'company', 'employee']).catch('project'),
  id: z.string(),
})
export type BoardOwner = z.infer<typeof BoardOwnerSchema>

// name — собственное редактируемое имя доски; departments — набор имён отделов
// (free-form, как теги; всегда массив, может быть пустым). Отдел не держит
// идентичность: в проекте допустимы несколько досок с пересекающимися отделами.
export const BoardSchema = z.object({
  id: z.string(),
  // Владельца может не быть в ответе (источник выкатывается параллельно) — тогда
  // доска читается как проектная; разбор владельца — boardOwner() в lib/owner.
  owner: BoardOwnerSchema.optional(),
  // Проект есть только у проектной доски; у доски компании и личной — пусто.
  projectId: z.string(),
  name: z.string(),
  departments: z.array(z.string()),
  // Порядок доски внутри проекта (сортировка по position). Consumers гардят `?? 0`.
  position: z.number().int().optional(),
  // Доска открыта заказчику компании — первая половина двойного гейта: задача
  // видна клиенту, только если открыты и доска, и сама задача. Отсутствие поля
  // читается как false (источник выкатывается параллельно); `_by`/`_at` — аудит.
  customerVisible: z.boolean().optional(),
  customerVisibleBy: z.string().nullable().optional(),
  customerVisibleAt: z.string().nullable().optional(),
  // Заказчик видит все задачи открытой доски, без пометки каждой.
  customerAllTasks: z.boolean().optional(),
  columns: z.array(ColumnSchema),
})
export type Board = z.infer<typeof BoardSchema>
